// extracted by mini-css-extract-plugin
module.exports = {"logo":"TheHeader_logo_1jfQp"};